import { Components, Theme } from '@mui/material/styles';

const formHelperTextTheme: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&.MuiFormHelperText-root": {
        ".MuiTypography-root": {
          color: theme.palette.coldWhite,
        },
      },
      "&.MuiFormHelperText-root.Mui-error": {
        fontSize: '16px'
      },
    })
  }
};

export default formHelperTextTheme;
